import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { BehaviorSubject, catchError, map, Observable, of, switchMap, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

import { AdminManagerSearchModel, BranchModel, PreAuthorisationModel, RegionModel } from '@lmsModels';

@Injectable({
  providedIn: 'root',
})
export class BranchService {

  private _lstallBranches: Observable<BranchModel[]>;
  private _lstlmsRegions = new BehaviorSubject<RegionModel[]>([]);

  BranchAdmin_apiURL = environment.apiUrl + '/loan/api/branch';
  userAudit_apiURL = `${environment.apiUrl}/loan/api/user-audit-trail`;

  HttpParamsOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  constructor(private http: HttpClient) {}

  saveBranch(branch: any) {
    return this.http.post<any>(this.BranchAdmin_apiURL + '/saveBranch', branch).pipe(
      map((responseData) => {
        return responseData;
      })
    );
  }

  getAllBranchesByAreaId(area: any) {
    return this.http.post<any>(`${this.BranchAdmin_apiURL}/getAllBranchesByAreaId`, area);
  }

  deleteBranch(branch: any) {
    return this.http.post<any>(this.BranchAdmin_apiURL + '/deleteBranch', branch).pipe(
      map((responseData) => {
        return responseData;
      })
    );
  }

  saveArea(area: any) {
    return this.http.post<any>(this.BranchAdmin_apiURL + '/saveArea', area).pipe(
      map((responseData) => {
        return responseData;
      })
    );
  }

  deleteArea(area: any) {
    return this.http.post<any>(this.BranchAdmin_apiURL + '/deleteArea', area).pipe(
      map((responseData) => {
        return responseData;
      })
    );
  }

  saveRegion(region: any) {
    return this.http.post<any>(this.BranchAdmin_apiURL + '/saveRegion', region).pipe(
      map((responseData) => {
        return responseData;
      })
    );
  }

  createRegion(region: any) {
    return this.http.post<any>(this.BranchAdmin_apiURL + '/createRegion', region).pipe(
      map((responseData) => {
        return responseData;
      })
    );
  }

  deleteRegion(region: any) {
    return this.http.post<any>(this.BranchAdmin_apiURL + '/deleteRegion', region).pipe(
      map((responseData) => {
        return responseData;
      })
    );
  }

  get lstBranchesObs() {
    return this._lstallBranches;
  }

  public get FinbondBranchList() {
    return this._lstallBranches.pipe(map((b) => b.values));
  }

  getAllFinbondBranches() {
    return this.http.get<any>(`${this.BranchAdmin_apiURL}/getAllBranches`).pipe(
      map((lst) => {
        return lst;
      })
    );
  }

  getAllFinbondBranchNames() {
    return this.http.get<any>(`${this.BranchAdmin_apiURL}/getAllFinbondBranchNames`);
  }

  handleBracnhListLoad(value: BranchModel[]) {
    this._lstallBranches = of(value);
    return this._lstallBranches;
  }

  // getAllFinbondBranches() {
  //   return this.http
  //   .get<BranchModel[]>(`${this.BranchAdmin_apiURL}/getAllBranches`);
  // }

  getAllBranchNames() {
    return this.http
      .get<BranchModel[]>(`${this.BranchAdmin_apiURL}/getAllBranchNames`)
      .pipe(switchMap((lst) => this.handleBracnhListLoad(lst)));
  }

  getAllAreas() {
    return this.http.get<any>(`${this.BranchAdmin_apiURL}/getAllAreas`);
  }

  getAllBranchesByRegion(region: any) {
    return this.http.get<any>(`${this.BranchAdmin_apiURL}/getAllBranchesByRegion/${region}`).pipe(
      map((res) => {
        return res;
      })
    );
  }

  getAllAreasByRegion(data: any) {
    if(!data) {
      return this.http.get<any>(`${this.BranchAdmin_apiURL}/getAllAreas`);
    }

    return this.http.post<any>(`${this.BranchAdmin_apiURL}/getAllAreasByRegion`, data);
    // .pipe(
    //   map((res) => {
    //     return res;
    //   })
    // );
  }

  getAllRegions() {
    return this.http.get<RegionModel[]>(`${this.BranchAdmin_apiURL}/getAllRegions`);
  }

  get lstLmsRegionsObs() {
    return this._lstlmsRegions.asObservable();
  }

  public get LMSRegionList() {
    return this._lstlmsRegions.value;
  }

  getAllLMSRegions() {
    return this.http.get<RegionModel[]>(`${this.BranchAdmin_apiURL}/getAllRegions`);
  }

  getAllBranchesByArea(area: any) {
    return this.http.post<any>(`${this.BranchAdmin_apiURL}/getAllBranchesByArea`, area).pipe(
      map((res) => {
        return res;
      })
    );
  }

  getBranchByName(branchName: any) {
    return this.http.post<any>(`${this.BranchAdmin_apiURL}/getBranchByName`, branchName).pipe(
      map((res) => {
        return res;
      })
    );
  }

  findLoansByDates(searchModel: any) {
    return this.http.post<any>(`${this.BranchAdmin_apiURL}/findLoansByDates`, searchModel).pipe(
      map((result: any) => {
        return result;
      })
    );
  }

  findLoansByStatus(idNumber: any) {
    return this.http.post<any>(`${this.BranchAdmin_apiURL}/findLoansByStatus`, idNumber).pipe(
      map((result: any) => {
        return result;
      })
    );
  }

  findLoansByIdNumber(searchModel: any) {
    return this.http.post<any>(`${this.BranchAdmin_apiURL}/findLoansByIdNumber`, searchModel).pipe(
      map((result: any) => {
        return result;
      })
    );
  }

  findLoansByClientNumber(searchModel: any) {
    return this.http.post<any>(`${this.BranchAdmin_apiURL}/findLoansByClientNumber`, searchModel).pipe(
      map((result: any) => {
        return result;
      })
    );
  }

  findLoanCountByDates(searchModel: any) {
    return this.http.post<any>(`${this.BranchAdmin_apiURL}/findLoanCountByDates`, searchModel).pipe(
      map((result: any) => {
        return result;
      })
    );
  }

  fetchBranchReport(startDate: string, endDate: string) {
    const params = new HttpParams()
      .set('startDate', startDate)
      .set('endDate', endDate);

    return this.http
      .get<any[]>(`${environment.apiUrl}/loan/api/client/fetchBranchReport`, { params })
      .pipe(map((result) => result));
  }

  fetchBranchReportByArea(createdOn: string, area: string) {
    const params = new HttpParams()
      .set('createdOn', createdOn)
      .set('area', area);

    return this.http
      .get<any[]>(`${environment.apiUrl}/loan/api/client/fetchBranchReportByArea`, { params })
      .pipe(map((result) => result));
  }

  findRegionLoanStats(searchModel: any) {
    return this.http.post<any>(`${this.BranchAdmin_apiURL}/findRegionLoanStats`, searchModel).pipe(
      map((result: any) => {
        return result;
      })
    );
  }

  findRegionAreaLoanStats(searchModel: any) {
    return this.http.post<any>(`${this.BranchAdmin_apiURL}/findRegionAreaLoanStats`, searchModel).pipe(
      map((result: any) => {
        return result;
      })
    );
  }

  branchPerformanceReport(searchModel: AdminManagerSearchModel) {
    return this.http.post<any>(`${this.BranchAdmin_apiURL}/branchPerformanceReport`, searchModel).pipe(
      map((res) => {
        return res;
      })
    );
  }

  getAllActiveBranchesByArea(selectedArea: string) {
    return this.http.post<any>(`${this.BranchAdmin_apiURL}/getAllActiveBranchesByArea`, selectedArea).pipe(
      map((result) => {
        return result;
      })
    );
  }

 findLoanById(loanId: number): Observable<PreAuthorisationModel> {
    // Validate input
    if (!loanId || isNaN(loanId)) {
        return throwError(() => new Error('Invalid loan ID'));
    }

    const params = new HttpParams().set('quoteId', loanId.toString());

    return this.http.get<PreAuthorisationModel>(
        `${this.BranchAdmin_apiURL}/findLoanById`,
        { params }
    ).pipe(
        catchError(error => {
            console.error('Error fetching loan:', error);
            return throwError(() => new Error('Failed to load loan details'));
        })
    );
}

  findAllLoans(filters: any): Observable<PreAuthorisationModel[]> {
    let params = new HttpParams();

    if (filters.loanId != null && filters.loanId !== '') {
      params = params.set('loanId', filters.loanId);
    }

    if (filters.startDate != null && filters.startDate !== '') {
      params = params.set('startDate', new Date(filters.startDate).toISOString());
    }

    if (filters.endDate != null && filters.endDate !== '') {
      params = params.set('endDate', new Date(filters.endDate).toISOString());
    }

    if (filters.branchName != null && filters.branchName !== '') {
      params = params.set('branchName', filters.branchName);
    }

    if (filters.loanReference != null && filters.loanReference !== '') {
      params = params.set('loanReference', filters.loanReference ?? '');
    }

    if (filters.clientNumber != null && filters.clientNumber !== '') {
      params = params.set('clientNumber', filters.clientNumber);
    }

    if (filters.idNumber != null && filters.idNumber !== '') {
      params = params.set('idNumber', filters.idNumber);
    }

    if (filters.fullName != null && filters.fullName !== '') {
      params = params.set('fullName', filters.fullName);
    }


    if (filters.loanStatus != null && filters.loanStatus !== '') {
      params = params.set('loanStatus', filters.loanStatus);
    }

    return this.http.get<PreAuthorisationModel[]>(
      `${this.BranchAdmin_apiURL}/getAllLoans`,
      { params }
    );
  }

   updateLoanStatus(payload: {quoteId: number; cancelReason?: string | null; areaManager?: string;}): Observable<any> {
       let params = new HttpParams()
      .set('quoteId', payload.quoteId);

    if (payload.cancelReason != null) {
      params = params.set('cancelReason', payload.cancelReason.toString());
    }

    if (payload.areaManager) {
      params = params.set('areaManager', payload.areaManager);
    }

    return this.http.post<any>(`${this.BranchAdmin_apiURL}/updateLoanStatus`, null, { params });
  }

   //new
   setLoanStatus(searchModel: any) {
    return this.http.post<any>(`${this.BranchAdmin_apiURL}/setLoanStatus`, searchModel).pipe(
      map((result: any) => {
        return result;
      })
    );
  }


     fetchClientChangeLogs(startDate: any, endDate: any, branchId: any) {
    const params = new HttpParams()
    .set('startDate', startDate)
    .set('endDate', endDate)
    .set('branchId', branchId);
    return this.http.post<any>(`${environment.apiUrl}/loan/api/client/fetchClientChangeLogs`, params).pipe(
      map((result) => {
        return result;
      })
    );
  }

    fetchClientChangeLogsByBranch(startDate: any, endDate: any, branchSerial: any) {
    const params = new HttpParams()
    .set('startDate', startDate)
    .set('endDate', endDate)
    .set('branchSerial', branchSerial);
    return this.http.post<any>(`${environment.apiUrl}/loan/api/client/fetchClientChangeLogsByBranch`, params).pipe(
      map((result) => {
        return result;
      })
    );
  }

   fetchOverrideData(startDate: any, endDate: any, branchSerial: any) {
    const params = new HttpParams()
    .set('startDate', startDate)
    .set('endDate', endDate)
    .set('branchSerial', branchSerial);
    return this.http.post<any>(`${environment.apiUrl}/loan/api/client/fetchOverrideDataByBranch`, params).pipe(
      map((result) => {
        return result;
      })
    );
  }

  getAuditTrailData(startDate: any, endDate: any, branchId: any) {
    const params = new HttpParams()
    .set('startDate', startDate)
    .set('endDate', endDate)
    .set('branchId', branchId);
    return this.http.post<any>(`${this.userAudit_apiURL}/fetchUserAuditTrail`, params).pipe(
      map((result) => {
        return result;
      })
    );
  }

  findLoansByIdNumberAndDates(searchModel: AdminManagerSearchModel) {
    return this.http.post<any>(`${this.BranchAdmin_apiURL}/findLoansByIdNumberAndDates`, searchModel).pipe(
      map((result: any) => {
        return result;
      })
    );
  }

  fetchCompletedBranchLoans(startDate: string, endDate: string) {
    const params = new HttpParams()
      .set('startDate', startDate)
      .set('endDate', endDate);

    return this.http
      .get<any[]>( // Use GET, not POST
        `${environment.apiUrl}/loan/api/client/fetchCompletedBranchLoans`,
        { params }, // Pass params in options object
      )
      .pipe(map((result) => result));
  }


 fetchNupayLoans(startDate: string, endDate: string) {
    const params = new HttpParams()
      .set('startDate', startDate)
      .set('endDate', endDate);

    return this.http
      .get<any[]>( // Use GET, not POST
        `${environment.apiUrl}/loan/api/client/fetchNupayReport`,
        { params }, // Pass params in options object
      )
      .pipe(map((result) => result));
  }

  fetchLmsDataReport(startDate: string, endDate: string) {
    const params = new HttpParams()
      .set('startDate', startDate)
      .set('endDate', endDate);

    return this.http
      .get<any[]>( // Use GET, not POST
        `${environment.apiUrl}/loan/api/client/fetchLmsDataReport`,
        { params }, // Pass params in options object
      )
      .pipe(map((result) => result));
  }

  fetchScanningMonitoringLoans(startDate: string, endDate: string) {
    const params = new HttpParams()
      .set('startDate', startDate)
      .set('endDate', endDate);

    return this.http
      .get<any[]>( // Use GET, not POST
        `${environment.apiUrl}/loan/api/client/fetchScanningMonitoringReport`,
        { params }, // Pass params in options object
      )
      .pipe(map((result) => result));
  }


  // findLoansByIdNumber(searchModel: any) {
  //   return this.http.post<any>(`${this.BranchAdmin_apiURL}/findLoansByIdNumber`, searchModel).pipe(
  //     map((result: any) => {
  //       return result;
  //     })
  //   );
  // }
  // getDevicesByBranch(branchNo: any) {
  //   return this.http
  //     .get<any>(this.DebicheckDevices_apiURL + '/findDevicesByBranch/' + branchNo)
  //     .pipe(
  //       map((result: any) => {
  //         return result;
  //       })
  //     );
  // }

  // findEmployersByName(data: any) {
  //   return this.http
  //   .post<BranchEmployer[]>(this.UpdateEmployer_apiURL + '/findEmployersByName',data)
  //     .pipe(
  //       //catchError(this.handleError),
  //       map((responseData) => {
  //       return responseData;
  //     }));
  // }
  // getAllBranchesByRegion(region: any) {
  //   return this.http
  //     .get<any>(`${this.BranchAdmin_apiURL}/getAllBranchesByRegion/${region}`)
  //     .pipe(
  //       map((res) => {
  //         return res;
  //       })
  //     );
  // }
}
